import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { DataGrid } from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Snackbar from '@mui/material/Snackbar';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Modal from '@mui/material/Modal';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import SettingsStatus from '../../../pages/General/SettingsStatus'
import { fetchBoxData, destoryBoxData, storeBoxData, updateBoxData, resetBoxState } from './boxSlice';
import NorowsData from '../../../pages/General/NorowsData'

// Reusable standard layout styling dictionary configuring premium outlined enterprise inputs
const enterpriseBoxFormInputStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': {
            borderColor: '#CBD5E1',
            boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
        },
        '&.Mui-focused': {
            borderColor: '#1976d2', // --- CORPORATE IDENTITY ACCENT BRAND BLUE ---
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiInputLabel-outlined': {
        color: '#64748B',
        fontWeight: 500,
        transform: 'translate(14px, 10px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1976d2',
            fontWeight: 600
        }
    },
    '& input, & .MuiSelect-select': {
        padding: '10px 14px !important',
        fontSize: '13.5px',
        color: '#1E293B',
        fontWeight: 500
    },
    '& .MuiFormHelperText-root': {
        mx: 0.5,
        mt: 0.75,
        fontWeight: 500
    }
};

const enterpriseBoxModalContainerStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '94%', sm: 640 },
    outline: 'none',
    border: 'none',
    boxSizing: 'border-box'
};

const enterpriseBoxDeleteModalStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 420 },
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    border: '1px solid #E2E8F0',
    p: 4,
    outline: 'none',
    overflow: 'hidden'
};

const Modalpopup = ({ modalVisible, setModalVisible, formValues, setFormValues, snackbar }) => {
    const dispatch = useDispatch();
    const profile = useSelector(state => state.auth.profile);

    const initialBoxValues = {
        box_name: '',
        box_length: '',
        box_length_unit: '',
        box_width: '',
        box_width_unit: '',
        box_height: '',
        box_height_unit: '',
        box_weight: '',
        box_weight_unit: '',
        box_active: true,
        box_default: false,
        use_actual_weight:false
    }

    const [values, setValues] = useState(formValues && Object.keys(formValues).length === 0 ? initialBoxValues : formValues);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (formValues && Object.keys(formValues).length !== 0) {
            let tempValues = {
                box_name: formValues['box_name'],
                box_length: formValues['box_length'],
                box_length_unit: formValues['box_length_unit'],
                box_width: formValues['box_width'],
                box_width_unit: formValues['box_width_unit'],
                box_height: formValues['box_height'],
                box_height_unit: formValues['box_height_unit'],
                box_weight: formValues['box_weight'],
                box_weight_unit: formValues['box_weight_unit'],
                box_default: formValues['box_default'],
                box_active: formValues['box_active'],
                dim_unit: formValues['box_length_unit'],
                use_actual_weight:formValues['use_actual_weight'] ? formValues['use_actual_weight']:false
            };
            setValues(tempValues)
        }
    }, [formValues])

    const onModalClose = () => {
        setModalVisible(false)
        setValues(initialBoxValues)
        setErrors({})
        setFormValues(initialBoxValues)
    }

    const validator = (fieldValues) => {
        let temp = { ...errors }
        if ('box_name' in fieldValues)
            temp.box_name = fieldValues.box_name ? "" : "This field is required."
        if (fieldValues && fieldValues.box_name && fieldValues.box_name.length < 3)
            temp.box_name = "Box Name required minimum 3 characters"
        if ('box_length' in fieldValues)
            temp.box_length = fieldValues.box_length ? "" : "This field is required."
        if (fieldValues && fieldValues.box_length && fieldValues.box_length <= 0)
            temp.box_length = "Length is not a negative number or 0"
        if ('box_length_unit' in fieldValues)
            temp.dim_unit = fieldValues.dim_unit ? "" : "This field is required."
        if ('box_width' in fieldValues)
            temp.box_width = fieldValues.box_width ? "" : "This field is required."
        if (fieldValues && fieldValues.box_width && fieldValues.box_width <= 0)
            temp.box_width = "Width is not a negative number  or 0"
        if ('box_height' in fieldValues)
            temp.box_height = fieldValues.box_height ? "" : "This field is required."
        if (fieldValues && fieldValues.box_height && fieldValues.box_height <= 0)
            temp.box_height = "Height is not a negative number  or 0"
        if ('box_weight' in fieldValues)
            temp.box_weight = fieldValues.box_weight ? "" : "This field is required."
        if (fieldValues && fieldValues.box_weight && fieldValues.box_weight <= 0)
            temp.box_weight = "Weight is not a negative number  or 0"
        if ('box_weight_unit' in fieldValues)
            temp.box_weight_unit = fieldValues.box_weight_unit ? "" : "This field is required."

        setErrors({
            ...temp
        })

        if (fieldValues === values)
            return Object.values(temp).every(x => x == "")
    }

    const onInputChange = e => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
        validator({ [name]: value })
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: e.target.checked,
        });
        validator({ [name]: value })
    };

    const handleSubmit = e => {
        e.preventDefault()
        const isValid = validator(values)
        if (isValid) {
            let tempValues = values
            let lengthUpdate=values.box_length
            let widthUpdate=values.box_width
            let heightUpdate=values.box_height
            let weightUpdate=values.box_weight
            lengthUpdate=parseFloat(lengthUpdate).toFixed(2)
            widthUpdate=parseFloat(widthUpdate).toFixed(2)
            heightUpdate=parseFloat(heightUpdate).toFixed(2)
            weightUpdate=parseFloat(weightUpdate).toFixed(2)
            values.box_length=lengthUpdate
            values.box_width=widthUpdate
            values.box_height=heightUpdate
            values.box_weight=weightUpdate
            tempValues["box_height_unit"] = tempValues["dim_unit"];
            tempValues["box_length_unit"] = tempValues["dim_unit"];
            tempValues["box_width_unit"] = tempValues["dim_unit"];
            if ("_id" in formValues) {
                dispatch(updateBoxData(profile && profile.id,formValues._id, tempValues))
                onModalClose()
                snackbar(true)
            } else {
                dispatch(storeBoxData(profile && profile.id,tempValues))
                onModalClose()
                snackbar(true)
            }
        }
    }

    return (
        <Modal
            open={modalVisible}
            onClose={onModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            closeAfterTransition
        >
            <Box sx={enterpriseBoxModalContainerStyles}>
                <Card 
                    className="sc--cardhead--details"
                    sx={{ 
                        backgroundColor: '#FFFFFF',
                        borderRadius: '16px',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        border: '1px solid #E2E8F0',
                        overflow: 'hidden'
                    }}
                >
                    <CardHeader 
                        title={
                            <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                Box Dimensions
                            </Typography>
                        } 
                        sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                    />
                    <Divider sx={{ borderColor: '#E2E8F0' }} />
                    <CardContent sx={{ p: 4, boxSizing: 'border-box' }}>
                        <Grid container spacing={3}>
                            
                            {/* Form Row 1: Box Label Template field */}
                            <Grid item xs={12}>
                                <Box sx={{ minHeight: '40px' }}>
                                    <TextField
                                        label="Box Name*"
                                        name="box_name"
                                        size="small"
                                        defaultValue={formValues && formValues.box_name}
                                        onChange={onInputChange}
                                        error={!!errors.box_name}
                                        helperText={errors.box_name}
                                        variant="outlined"
                                        sx={enterpriseBoxFormInputStyles}
                                    />
                                </Box>
                            </Grid>

                            {/* Form Row 2: Length & Width Numeric field group */}
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ minHeight: '40px' }}>
                                    <TextField
                                        label="Length*"
                                        type='number'
                                        name="box_length"
                                        size="small"
                                        defaultValue={formValues && formValues.box_length}
                                        onChange={onInputChange}
                                        error={!!errors.box_length}
                                        helperText={errors.box_length}
                                        variant="outlined" 
                                        sx={enterpriseBoxFormInputStyles}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ minHeight: '40px' }}>
                                    <TextField
                                        label="Width*"
                                        name="box_width"
                                        type='number'
                                        size="small"
                                        defaultValue={formValues && formValues.box_width}
                                        onChange={onInputChange}
                                        error={!!errors.box_width}
                                        helperText={errors.box_width}
                                        variant="outlined" 
                                        sx={enterpriseBoxFormInputStyles}
                                    />
                                </Box>
                            </Grid>

                            {/* Form Row 3: Height & Unified Dimension measurement context dropdown field group */}
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ minHeight: '40px' }}>
                                    <TextField
                                        label="Height*"
                                        name="box_height"
                                        type='number'
                                        size="small"
                                        defaultValue={formValues && formValues.box_height}
                                        onChange={onInputChange}
                                        error={!!errors.box_height}
                                        helperText={errors.box_height}
                                        variant="outlined" 
                                        sx={enterpriseBoxFormInputStyles}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ minHeight: '40px' }}>
                                    <FormControl variant="outlined" size="small" sx={enterpriseBoxFormInputStyles} error={!!errors.dim_unit}>
                                        <InputLabel id="dim-unit-select-outlined-label">Dimension Unit*</InputLabel>
                                        <Select
                                            labelId="dim-unit-select-outlined-label"
                                            id="dim-unit-select-outlined"
                                            name="dim_unit"
                                            defaultValue={formValues && formValues.box_length_unit}
                                            onChange={onInputChange}
                                            label="Dimension Unit*"
                                        >
                                            <MenuItem value={"in"}>in</MenuItem>
                                            <MenuItem value={"cm"}>cm</MenuItem>
                                        </Select>
                                        {errors.dim_unit && <FormHelperText>{errors.dim_unit}</FormHelperText>}
                                    </FormControl>
                                </Box>
                            </Grid>

                            {/* Form Row 4: Static Base Weight & Unit selector elements dropdown field group */}
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ minHeight: '40px' }}>
                                    <TextField
                                        label="Weight*"
                                        name="box_weight"
                                        type='number'
                                        size="small"
                                        defaultValue={formValues && formValues.box_weight}
                                        onChange={onInputChange}
                                        error={!!errors.box_weight}
                                        helperText={errors.box_weight}
                                        variant="outlined" 
                                        sx={enterpriseBoxFormInputStyles}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ minHeight: '40px' }}>
                                    <FormControl variant="outlined" size="small" sx={enterpriseBoxFormInputStyles} error={!!errors.box_weight_unit}>
                                        <InputLabel id="weight-unit-select-outlined-label">Weight Unit*</InputLabel>
                                        <Select
                                            labelId="weight-unit-select-outlined-label"
                                            id="weight-unit-select-outlined"
                                            name="box_weight_unit"
                                            defaultValue={formValues && formValues.box_weight_unit}
                                            onChange={onInputChange}
                                            label="Weight Unit*"
                                        >
                                            <MenuItem value={"kg"}>kg</MenuItem>
                                            <MenuItem value={"lb"}>lb</MenuItem>
                                            <MenuItem value={"g"}>g</MenuItem>
                                        </Select>
                                        {errors.box_weight_unit && <FormHelperText>{errors.box_weight_unit}</FormHelperText>}
                                    </FormControl>
                                </Box>
                            </Grid>

                            {/* Form Row 5: Operational Toggles Setup Section Dashboard cards row */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap', p: 2, backgroundColor: '#F8FAFC', borderRadius: '12px', border: '1px solid #E2E8F0' }}>
                                    <FormGroup>
                                        <FormControlLabel 
                                            control={<Switch defaultChecked={formValues && formValues.box_default} name="box_default" onChange={handleChange} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#1976d2' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#1976d2' } }} />} 
                                            label={<Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: '#334155' }}>Default Profile</Typography>} 
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControlLabel 
                                            control={<Switch defaultChecked={formValues && formValues.use_actual_weight} name="use_actual_weight" onChange={handleChange} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#1976d2' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#1976d2' } }} />} 
                                            label={<Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: '#334155' }}>Use Actual Weight</Typography>} 
                                        />
                                    </FormGroup>
                                </Box>
                            </Grid>

                            {/* Form Row 6: Modal Actions Pipeline Confirmation Footer Bar */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, pt: 2, borderTop: '1px solid #E2E8F0', mt: 1 }}>
                                    <Button 
                                        variant="outlined" 
                                        onClick={onModalClose}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            fontSize: '13.5px',
                                            height: '38px',
                                            px: 3,
                                            borderColor: '#E2E8F0',
                                            color: '#475569',
                                            '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        onClick={handleSubmit}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            fontSize: '13.5px',
                                            height: '38px',
                                            px: 4,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2',
                                            color: '#FFFFFF',
                                            '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            </Grid>

                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Modal >
    )
}

const BoxPage = () => {
    const dispatch = useDispatch();
    const box = useSelector(state => state.box);
    const profile = useSelector(state => state.auth.profile);
    const [alert, setAlert] = useState(false);
    const [snackOpen, setSnackOpen] = React.useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [deleteid, setDeleteId] = React.useState("");
    const [deleteModalopen, setDeleteModalopen] = React.useState(false);
    const [boxDimensions, setboxDimensions] = useState([]);

    useEffect(() => {
        dispatch(fetchBoxData());
    }, [dispatch]);

    useEffect(() => {
        if (box && box.message) {
            setAlert(true)
            setSnackOpen(true)
        }
        let myArray = box && box.data.filter(function( obj ) {
             return  obj.hide !== true;
          });
          setboxDimensions(myArray)
    }, [box]);

    const handleClick = (id) => {
        setDeleteId(id)
        setDeleteModalopen(true);
    };

    const deleteModalClose = () => {
        setDeleteModalopen(false);
    };

    const deletebox = (id) => {
        dispatch(destoryBoxData(profile && profile.id,id))
        setAlert(true)
        setSnackOpen(true)
        setDeleteModalopen(false);
    }

    const snackhandleClose = () => {
        setSnackOpen(false)
        setAlert(false)
        dispatch(resetBoxState())
    };

    const snackbar = (value) => {
        setSnackOpen(value)
    }

    const columns = [
        { field: 'box_name', headerName: 'Box Name', flex:1.2 },
        { field: 'box_length', headerName: 'Length', flex:1 },
        { field: 'box_width', headerName: 'Width', flex:1},
        { field: 'box_height', headerName: 'Height', flex:1 },
        { field: 'box_length_unit', headerName: 'Dimension Unit', flex:1},
        { field: 'box_weight', headerName: 'Weight', flex:1},
        {
            field: 'box_active',
            headerName: 'Active',
            flex:1,
            renderCell: (params) => {
                return <SettingsStatus settingsStatus={params.row.box_active} />
            }
        },
        {
            field: 'box_default',
            headerName: 'Default',
            flex:1,
            renderCell: (params) => {
                return <SettingsStatus settingsStatus={params.row.box_default} />
            }
        },
        {
            field: 'use_actual_weight',
            headerName: 'Use Actual Weight',
            flex:1.2,
            renderCell: (params) => {
                let status=false;
                if(params && params.row && params.row.use_actual_weight){
                    status=params.row.use_actual_weight
                }
                return <SettingsStatus settingsStatus={status} />
            }
        },
        {
            field: 'action',
            headerName: 'Action',
            flex:1,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
                        <Tooltip title="Edit Package" placement="top">
                            <IconButton
                                onClick={() => {
                                    setSelectedItem(params.row);
                                    setModalVisible(true)
                                }}
                                sx={{ 
                                    color: '#64748B', padding: '6px', borderRadius: '8px', border: '1px solid #E2E8F0', backgroundColor: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1', color: '#1E293B' }
                                }}
                            >
                                <EditIcon sx={{ fontSize: '16px' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Package" placement="top">
                            <IconButton
                                onClick={(e) => {
                                    handleClick(params.row._id)
                                }}
                                sx={{ 
                                    color: '#EF4444', padding: '6px', borderRadius: '8px', border: '1px solid #FEE2E2', backgroundColor: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#FEF2F2', borderColor: '#FCA5A5' }
                                }}
                            >
                                <DeleteOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )
            }
        }
    ];

    return (
        <Box className="sc--settings--card" sx={{ width: '100%', boxSizing: 'border-box', p: 2.5 }}>
            <Modalpopup
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                formValues={selectedItem}
                setFormValues={setSelectedItem}
                snackbar={snackbar}
            />

            {/* Modal 2: Irreversible Entity Wipe Dialogue */}
            <Modal
                open={deleteModalopen}
                onClose={deleteModalClose}
                aria-labelledby="delete-modal-title"
                aria-describedby="delete-modal-description"
                closeAfterTransition
            >
                <Box sx={enterpriseBoxDeleteModalStyles}>
                    <Typography id="delete-modal-title" variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', mb: 1.5, textAlign: 'center', fontSize: '16px' }}>
                        Delete Box Dimensions
                    </Typography>
                    <Typography id="delete-modal-description" variant="body2" sx={{ color: '#475569', fontWeight: 500, lineHeight: 1.6, mb: 4, textAlign: 'center' }}>
                        Are you sure want to delete this box dimensions?<br />This optimization profile structural mapping is permanent.
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, width: '100%' }}>
                        <Button 
                            variant="outlined" 
                            onClick={deleteModalClose}
                            sx={{
                                textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 3.5,
                                borderColor: '#E2E8F0', color: '#475569', '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                            }}
                        >
                            No, Keep
                        </Button>
                        <Button 
                            variant="contained" 
                            onClick={(event) => deletebox(deleteid)}
                            sx={{
                                textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 4.5, boxShadow: 'none',
                                backgroundColor: '#EF4444', color: '#FFFFFF', '&:hover': { backgroundColor: '#DC2626', boxShadow: 'none' }
                            }}
                        >
                            Yes, Delete
                        </Button>
                    </Box>
                </Box>
            </Modal>

            {alert && (box && box.loading === false) &&
                <Snackbar
                    open={snackOpen}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    autoHideDuration={6000}
                    onClose={snackhandleClose}
                    sx={{ mt: 2 }}
                >
                    <Alert
                        severity={box && box.hasErrors === true ? "error" : "success"}
                        onClose={snackhandleClose}
                        variant="filled"
                        sx={{ width: '100%', borderRadius: '12px', fontWeight: 600, boxShadow: '0 10px 15px -3px rgba(0,0,0,0.05)', fontSize: '13px', alignItems: 'center' }}
                    >
                        {box && box.message}
                    </Alert>
                </Snackbar>
            }

            {/* Core Card Grid Data Surface Panel Container */}
            <Card 
                sx={{ 
                    width: '100%', 
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden'
                }} 
                className="sc--cardhead--details"
            >
                <Box 
                    sx={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2.5, borderBottom: '1px solid #E2E8F0', flexWrap: 'wrap', gap: 2
                    }}
                >
                    <Typography variant="h5" component="h1" sx={{ fontWeight: 800, color: '#0F172A', letterSpacing: '-0.5px', margin: 0, fontSize: '1.25rem' }}>
                        Box Dimensions
                    </Typography>
                    <Button 
                        variant="contained" 
                        onClick={() => { setModalVisible(true) }}
                        sx={{
                            textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 3, boxShadow: 'none',
                            backgroundColor: '#1976d2', color: '#FFFFFF', '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                        }}
                    >
                        Add Box
                    </Button>
                </Box>
                <Divider sx={{ display: 'none' }} />
                <CardContent sx={{ p: 0 }}>
                    <Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                        <DataGrid
                            sx={{
                                border: 'none',
                                backgroundColor: '#FFFFFF',
                                overflow: 'hidden',
                                '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                                '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
                                '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                                '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                                '& .MuiDataGrid-cell': { borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                                '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                            }}
                            getRowId={(row) => row._id}
                            disableRowSelectionOnClick={true}
                            rows={boxDimensions}
                            columns={columns}
                            autoHeight={true}
                            slots={{
                                loadingOverlay: LinearProgress,
                                noRowsOverlay: NorowsData
                            }}
                            hideFooter={true}
                            loading={box && box.loading}
                        />
                    </Box>
                </CardContent>
            </Card>
        </Box>
    )
}

export default BoxPage;